import { BaseConfig } from "../config.interface";

interface IStepperConfig {
}
export class StepperConfig extends BaseConfig<IStepperConfig> implements IStepperConfig {

    /**
     * @theme Base
     */
    static baseTheme = {
        Default: new StepperConfig({
        }),
    };
}